export default __webpack_public_path__ + "static/image8-fd7f44daff785f6d1f74c55d5ab65282.jpg";